/**
 * Esegue `update` (una funzione che cambia stato React/DOM) dentro una View
 * Transition nativa del browser quando disponibile — crossfade automatico
 * tra lo stato prima/dopo, zero animazione da scrivere a mano. Fallback:
 * esegue `update` e basta sui browser che non la supportano.
 */
export function withViewTransition(update) {
  if (typeof document === 'undefined' || !document.startViewTransition) {
    update();
    return;
  }
  document.startViewTransition(() => update());
}
